import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GRAY, WHITE } from '../Styles';

export const ValueChanger = observer(
  ({
    incrementValue = 50,
    label,
    maxValue = 500,
    minValue = 100,
    onClick,
    value,
  }) => {
    const [decDisabled, setDecDisabled] = useState(false);
    const [incDisabled, setIncDisabled] = useState(false);

    const handleDisablement = (newValue) => {
      setDecDisabled(newValue <= minValue);
      setIncDisabled(newValue >= maxValue);
    };

    const increaseValue = () => {
      const newValue = value + incrementValue;
      onClick(newValue);
      handleDisablement(newValue);
    };

    const decreaseValue = () => {
      const newValue = value - incrementValue;
      onClick(newValue);
      handleDisablement(newValue);
    };

    useEffect(() => {
      handleDisablement(value);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <FieldsWrapper>
        <Label>{label}</Label>
        <ValueContainer>
          <Button
            disabled={decDisabled}
            onClick={() => !decDisabled && decreaseValue()}
          >
            -
          </Button>
          <Value>{value}</Value>
          <Button
            disabled={incDisabled}
            onClick={() => !incDisabled && increaseValue()}
          >
            +
          </Button>
        </ValueContainer>
      </FieldsWrapper>
    );
  },
);

export default ValueChanger;

export const Label = styled.label`
  font-weight: bold;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 35px;
  min-width: 35px;
  border-radius: 50%;
  border: 1px solid ${GRAY};
  font-size: 1rem;
  font-weight: 900;
  color: ${WHITE};
  :hover {
    background-color: ${GRAY};
    cursor: pointer;
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-evenly;
`;

export const Value = styled.div`
  font-weight: bold;
  font-size: clamp(0.8rem, 1.2vw, 1.2rem);
`;
